import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NetzbetreiberPageComponent } from './netzbetreiber-page/netzbetreiber-page.component';
import { NetzbetreiberDetailComponent } from './netzbetreiber-detail/netzbetreiber-detail.component';
import { AuthGuard } from '../service/auth/auth.guard';
import { RoleAuthGuard } from '../service/auth/role-auth.guard';
import { UserRoles } from '../domain/model/roles.enum';

export const netzbetreiberRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Netzbetreiber
        path: 'list',
        component: NetzbetreiberPageComponent,
        canActivate: [
            AuthGuard,
            RoleAuthGuard,
        ],
        data: {
            allowedRoles: [
                UserRoles.TDL_ADMIN_USER,
                UserRoles.TDL_WESTNETZ_USER,
            ],
        },
    },
    {
        path: 'detail',
        component: NetzbetreiberDetailComponent,
        canActivate: [
            AuthGuard,
            RoleAuthGuard,
        ],
        data: {
            allowedRoles: [
                UserRoles.TDL_ADMIN_USER,
                UserRoles.TDL_WESTNETZ_USER,
                UserRoles.TDL_VNB_USER,
            ],
        },
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(netzbetreiberRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class NetzbetreiberRoutingModule {
}
